import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=c20a390e&"
import script from "./InfoRow.vue?vue&type=script&lang=js&"
export * from "./InfoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports